// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".book-detail-action-grid[data-v-8927966c]{align-items:stretch;display:grid;gap:12px;grid-template-columns:minmax(0,1fr) 48px}.book-detail-action-grid[data-v-8927966c]>:first-child{min-height:48px;min-width:0}.book-detail-collection-action[data-v-8927966c]{grid-column:1/-1;margin-top:0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
